import Vue from 'vue'
import VueRouter from 'vue-router'
import { exitFromAppGuard } from '@shared/utils/routerHelpers'
import { routes } from '@/router'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes,
    linkExactActiveClass: 'active',
    linkActiveClass: 'active',
    scrollBehavior (to, from, savedPosition) {
        return new Promise((resolve) => {
            setTimeout(() => {
                return resolve(scrollCoordinates(to, from, savedPosition))
            }, 500)
        })
    }
})

const scrollCoordinates = (to, from, savedPosition) => {
    if (to.hash) {
        return {
            selector: to.hash
        }
    }

    if (savedPosition) {
        return savedPosition
    } else {
        return { x: 0, y: 0 }
    }
}

router.beforeEach(exitFromAppGuard)

export default router
